import { render, staticRenderFns } from "./transaction.vue?vue&type=template&id=c2111bd8&scoped=true"
import script from "./transaction.vue?vue&type=script&lang=js"
export * from "./transaction.vue?vue&type=script&lang=js"
import style0 from "./transaction.vue?vue&type=style&index=0&id=c2111bd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2111bd8",
  null
  
)

export default component.exports